// extracted by mini-css-extract-plugin
export default {"uploaded":"FileUploadButton_uploaded__2P8gu","button":"FileUploadButton_button__-h2UO"};